import { ofetch, type FetchOptions } from 'ofetch'

let getTokenFn: () => Promise<string | undefined> = async () => undefined

// Requests can fire from child-component effects before the TokenBridge
// parent effect registers the real getter (child effects run first in React).
// Hold the first volley until registration so nothing goes out tokenless.
let resolveReady: (() => void) | undefined
const tokenGetterReady = new Promise<void>(resolve => { resolveReady = resolve })

export function registerTokenGetter(fn: () => Promise<string | undefined>) {
  getTokenFn = fn
  resolveReady?.()
}

async function applyAuth(options: FetchOptions): Promise<void> {
  await tokenGetterReady
  const token = await getTokenFn()
  if (!token) return

  const headers: Record<string, string> = {}
  if (options.headers) {
    const existing =
      options.headers instanceof Headers
        ? Object.fromEntries(options.headers.entries())
        : (options.headers as Record<string, string>)
    Object.assign(headers, existing)
  }
  headers.Authorization = `Bearer ${token}`
  options.headers = headers
}

export const api = ofetch.create({
  baseURL: import.meta.env.VITE_API_URL,
  async onRequest({ options }) {
    await applyAuth(options)
  },
})
